export default __webpack_public_path__ + "img/default2.607c724c.jpg";